import React, { useState, useRef, useEffect } from "react";
import CustomButton from "./CustomButton";
import NavigationTabs from "./NavigationTabs";
import icons from "./icons";
import icon from "../helpers/useIcon";
import { useTheme } from "@mui/material/styles";
import { base64ToImageUrl, isBase64Image } from "../helpers/imageHelper";
const GrupoArticuloTabs = ({ grupoArticulo = [], selectedGrupo, onGrupoSelect, innerWidth = false, dynamicColor }) => {
  const theme = useTheme();

  const navigationItems = grupoArticulo.map((ga) => {
    let iconToUse;
    let isImageIcon = false;

    if (ga.imagen && isBase64Image(ga.imagen)) {
      // Usar imagen base64
      iconToUse = base64ToImageUrl(ga.imagen);
      isImageIcon = true;
    } else {
      // Usar sistema anterior de iconos
      iconToUse = icons[icon(ga.descripcion)];
      isImageIcon = false;
    }

    return {
      id: ga.idCategoriaTotem,
      label: ga.descripcion,
      customComponent: CustomButton,
      componentProps: {
        description: ga.descripcion,
        icon: iconToUse,
        isImageIcon: isImageIcon,
        sizeIcon: ga.descripcion=== 'HELADERA'? 21:25,
        fontSize: 6,
      },
      onClick: () => onGrupoSelect && onGrupoSelect(ga.idCategoriaTotem)
    };
  });

  const handleItemSelect = (item) => {
    if (item.onClick) {
      item.onClick();
    }
  };

  return (
    <NavigationTabs
      items={navigationItems}
      selectedItem={selectedGrupo}
      onItemSelect={handleItemSelect}
      innerWidth={innerWidth}
      buttonStyle="custom"
      itemsPerPage={4}
      dynamicColor={dynamicColor}
    />
  );
};

export default GrupoArticuloTabs;
